// External libraries
import { useQuery } from '@apollo/react-hooks';

// Internal modules
import { getLocale, getToken } from '@/lib/globals';
import { SUPPORTED_FUNDING_SOUCRES_QUERY } from '../../graphql/queries';

const useSupportedFundingSourcesQuery = () => {
  return useQuery(SUPPORTED_FUNDING_SOUCRES_QUERY, {
    variables: {
      token: getToken(),
      userCountry: getLocale().country,
    },
  });
};

export { useSupportedFundingSourcesQuery };
